import { dataMember, required } from 'santee-dcts';

export class EQueryCCQuestion {
    @dataMember()
    @required()
    public questionId: number;    

    @dataMember()
    @required()
    public issueType: string;

    @dataMember()
    @required({ nullable: true })
    public issueDescription: string;

    @dataMember()
    @required({ nullable: true })
    public responseMask: string;

    @dataMember()
    @required({ nullable: true })
    public responseMaskDescription: string;

    @dataMember()
    @required()
    public queryText: string;
}
